import styled from 'styled-components';
import { colors, grid } from '@zopauk/react-components';

export const Columns = styled.div`
  display: flex;
  align-items: center;

  margin-left: -15px;
  margin-right: -15px;
  color: ${colors.greyDarkest};
  font-size: 18px;

  .column {
    padding: 0 15px;
    font-weight: 700;

    > div {
      font-weight: 400;
      font-size: 14px;
    }
  }

  @media screen and (max-width: ${grid.breakpoints.m}px) {
    flex-wrap: wrap;

    .column {
      margin-bottom: 10px;
    }

    .icon-column {
      position: absolute;
      top: 20px;
      right: 26px;
      padding: 0;

      svg {
        width: 30px;
      }
    }
  }

  .primary-column span,
  .secondary-column span {
    font-size: 14px;
    font-weight: 400;
  }

  .discovery & .primary-column {
    max-width: 200px;
  }

  .max-w-300 {
    max-width: 300px;
  }
  .max-w-500 {
    max-width: 500px;
  }

  h3 {
    margin: 0;
    font-size: 18px;
  }

  .max-w-500 {
    max-width: 500px;
  }
`;
